import type { CSSProperties } from 'react';

import { getBackgroundColorStyle } from '@/utils/background';

import { cn } from '../../utils/cn';

import * as styles from '../Navbar.css';
import { NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2 } from './NavbarMenuDropdownColumn.constants';
import type { NavbarMenuDropdownColumnV2ElementProps } from './NavbarMenuDropdownColumn.type';

export function NavbarMenuDropdownColumnV2(props: NavbarMenuDropdownColumnV2ElementProps) {
  const { element, className, children, attributes } = props;
  const {
    customAttributes,
    label,
    padding,
    borderRadius,
    gap,
    background,
    borderWidth,
    borderStyle,
    borderColor,
    mobilePadding,
    mobileBorderRadius,
    mobileBorderWidth,
    mobileBorderStyle,
    mobileBorderColor,
    mobileGap,
  } = element.attrs || {};

  return (
    <div
      {...props}
      {...customAttributes}
      {...attributes}
      className={cn(styles.navbarDropdownColumnV2, className)}
      style={
        {
          '--padding': padding ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.padding,
          '--gap': gap ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.gap,
          '--column-border-radius': borderRadius ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.borderRadius,
          '--column-border-width': borderWidth ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.borderWidth,
          '--column-border-style': borderStyle ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.borderStyle,
          '--column-border-color': borderColor ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.borderColor,
          ...getBackgroundColorStyle(background ?? NAVBAR_MENU_DROPDOWN_COLUMN_DEFAULTS_V2.background),
          '--mobile-padding': mobilePadding ?? padding,
          '--mobile-border-radius': mobileBorderRadius ?? borderRadius,
          '--mobile-border-width': mobileBorderWidth ?? borderWidth,
          '--mobile-border-style': mobileBorderStyle ?? borderStyle,
          '--mobile-border-color': mobileBorderColor ?? borderColor,
          '--mobile-gap': mobileGap ?? gap,
        } as CSSProperties
      }
    >
      {label && <div className={styles.navbarDropdownColumnLabelV2}>{label}</div>}
      {children}
    </div>
  );
}
